import React, { useEffect, useState } from "react";
import { Controller, FormProvider, useFormContext } from "react-hook-form";
import { formConfig } from "./formConfig";
import { ColorPicker } from "./ColorPicker";
import DimensionPicker from "./DimensionPicker";
import { ShapePicker } from "./ShapePicker";
import { LuShoppingCart } from "react-icons/lu";
import { MdAddShoppingCart } from "react-icons/md";
import { YesNoPicker } from "./YesNoPicker";

export const DynamicForm = ({ add_order, orders, openBasket }) => {
  const { register, handleSubmit,  control, reset } = useFormContext({
    defaultValues: {
      FRAME_COLOR: "RAL 9016",
      DIMENSION: {HEIGHT: 500, WIDTH: 500}
    },
  });

  console.log("rerender dynamicform");
  const onError = (errors) => {
    console.log("Form errors:", errors);
    //console.log("Form State Errors:", formState);
  };

  const onSubmit = (data) => {
    console.log("Form Data:", data);
    //console.log(formState.errors);
    add_order(data);
    //Reset form
    reset({
      DIMENSION: {HEIGHT: 1500, WIDTH: 700}
    })

    /* nog uitbreiden met kleur en gaastype vast te zetten:
    ({
  fieldName: "new value", // Specificeer de nieuwe waarde
});

*/
  };

  return (
    <>
      <button
        onClick={openBasket}
        type="button"
        className="absolute z-50 top-0 right-0 m-4 inline-flex items-center p-3 text-sm font-medium text-center text-white bg-blue-600 rounded-lg hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
      >
        <LuShoppingCart className="text-white font-black" />
        <span className="sr-only">Notifications</span>
        <div className="absolute inline-flex items-center justify-center w-6 h-6 text-xs font-bold text-white bg-amber-600 border-2 border-white rounded-full -top-2 -end-2 dark:border-gray-900">
          {orders.length}
        </div>
      </button>

      <div className="p-2 pb-0 overflow-y-auto	">
        <h1 className="ml-2 my-3 text-4xl font-extrabold text-gray-800 dark:text-white">
         Zoemzoem
        </h1>

        <form onSubmit={handleSubmit(onSubmit, onError)} className="space-y-2">
          {formConfig.map((con) => {
            switch (con.type) {
              case "colorPicker":
                return (
                  <Controller
                  key={con.name}
                    name={con.name}
                    control={control}
                    rules={{ required: "Colorrrrr is required" }}
                    defaultValue={con.defaultValue}
                    render={({ field, fieldState }) => (
                      <ColorPicker
                        key={con.name}
                        name={con.name}
                        label={con.label}
                        options={con.options}
                        //errors={"test"}
                        errors={fieldState?.error}
                        selectedColor={field.value}
                        //errors={errors[con.name]}
                        title={con.title}
                        detailed_label={con.detailed_label}
                        validation={con.validation}
                      />
                    )}
                  />
                );
                

              case "shapePicker":
                return (
                  <Controller
                  key={con.name}

                  name={con.name}
                  control={control}
                  defaultValue={con.defaultValue}
                  render={({ field, fieldState }) => (
                  <ShapePicker
                    key={con.name}
                    name={con.name}
                    label={con.label}
                    options={con.options}
                    selectedColor={field.value}
                    title={con.title}
                    detailed_label={con.detailed_label}
                    validation={con.validation}
                    errors={fieldState?.error}

                  />
                )}
                />
                );

              case "dimensionPicker":
                return (
                  <Controller
                  key={con.name}

                  name={con.name}
                  control={control}
                  defaultValue={{WIDTH: '700', HEIGHT: '1500'}}

                  render={({ field, fieldState }) => (

                  <DimensionPicker
                    validation={con.validation}
                    title={con.title}
                    detailed_label={con.detailed_label}
                    key={con.name}
                    name={con.name}
                    label={con.label}
                    errors={fieldState?.error}

                  />
                  )}/>
                );

              case "yesnoPicker":
                return (
                  <Controller
                  key={con.name}

                  name={con.name}
                  control={control}
                  render={({ f, fieldState }) => (
                  <YesNoPicker
                    validation={con.validation}
                    title={con.title}
                    detailed_label={con.detailed_label}
                    key={con.name}
                    name={con.name}
                    errors={fieldState?.error}
                    label={con.label}
                  />
                )}
                />
                  
                );

              case "text":
                return (
                  <div key={con.name}>
                    <label
                      htmlFor={con.name}
                      className="block text-sm font-medium"
                    >
                      {con.label}
                    </label>
                    <input
                      type="text"
                      id={con.name}
                      {...register(con.name, con.validation)}
                      className="w-full border rounded p-2"
                      placeholder={con.placeholder}
                    />
                  </div>
                );

              case "number":
                return (
                  <div key={con.name}>
                    <label
                      htmlFor={con.name}
                      className="block text-sm font-medium"
                    >
                      {con.label}
                    </label>
                    <input
                      type="number"
                      id={con.name}
                      {...register(con.name, con.validation)}
                      className="w-full border rounded p-2"
                      placeholder={con.placeholder}
                    />
                  </div>
                );

              case "checkbox":
                return (
                  <div key={con.name} className="flex items-center space-x-2">
                    <input
                      type="checkbox"
                      id={con.name}
                      {...register(con.name, con.validation)}
                      className="rounded border-gray-300"
                    />
                    <label htmlFor={con.name} className="text-sm font-medium">
                      {con.label}
                    </label>
                  </div>
                );

              default:
                return null;
            }
          })}

          <div className="h-auto flex justify-between items-end mb-0 bg-green">
            <div className="h-auto flex items-center h-5 bg-red">
              <div>
                <label
                  htmlFor="aantal"
                  className="block mb-2 text-sm font-medium text-gray-900 dark:text-white"
                >
                  Hoeveel wil u er bestellen?
                </label>

                <input
                  type="number"
                  defaultValue={1}
                  id="aantal"
                  {...register("AANTAL")}
                  className="bg-gray-50 w-full border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="1"
                />
              </div>
            </div>
            <button
              type="submit"
              className="text-white bg-blue-600 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center inline-flex items-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
            >
              <MdAddShoppingCart className="text-white font-black text-lg" />
              &nbsp; Voeg toe
            </button>
          </div>
        </form>
      </div>
    </>
  );
};
